<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col>
          <div class="calculator">
            <div class="display">
              <v-spacer />
              {{ calcul }} <span v-if="calcul !== ''" class="ml-2">=</span>
            </div>
            <div class="answer">
              <v-spacer />
              {{ answer }}
            </div>

            <div class="display">
              <v-spacer />
              {{ logList + current }}
            </div>
            <div @click="clear" id="clear" class="btn operator">C</div>
            <div @click="sign" id="sign" class="btn operator">+/-</div>
            <div @click="percent" id="percent" class="btn operator">%</div>
            <div @click="divide" id="divide" class="btn operator">/</div>
            <div @click="append('7')" id="n7" class="btn">7</div>
            <div @click="append('8')" id="n8" class="btn">8</div>
            <div @click="append('9')" id="n9" class="btn">9</div>
            <div @click="times" id="times" class="btn operator">*</div>
            <div @click="append('4')" id="n4" class="btn">4</div>
            <div @click="append('5')" id="n5" class="btn">5</div>
            <div @click="append('6')" id="n6" class="btn">6</div>
            <div @click="minus" id="minus" class="btn operator">-</div>
            <div @click="append('1')" id="n1" class="btn">1</div>
            <div @click="append('2')" id="n2" class="btn">2</div>
            <div @click="append('3')" id="n3" class="btn">3</div>
            <div @click="plus" id="plus" class="btn operator">+</div>
            <div @click="append('0')" id="n0" class="zero">0</div>
            <div @click="dot" id="dot" class="btn">.</div>
            <div @click="equal" id="equal" class="btn operator">=</div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import anime from "animejs/lib/anime.es.js";

export default {
  name: "MyCalculate",
  data() {
    return {
      logList: "",
      current: "",
      answer: "",
      calcul: "",
      operatorClicked: true,
    };
  },
  methods: {
    append(number) {
      if (this.operatorClicked) {
        this.current = "";
        this.operatorClicked = false;
      }
      this.animateNumber(`n${number}`);
      this.current = `${this.current}${number}`;
    },
    addtoLog(operator) {
      if (this.operatorClicked == false) {
        this.logList += `${this.current} ${operator} `;
        this.current = "";
        this.operatorClicked = true;
      }
    },
    animateNumber(number) {
      let tl = anime.timeline({
        targets: `#${number}`,
        duration: 250,
        easing: "easeInOutCubic",
      });
      tl.add({ backgroundColor: "#87a8cd" });
      tl.add({ backgroundColor: "#5ca8e1" });
    },
    animateOperator(operator) {
      let tl = anime.timeline({
        targets: `#${operator}`,
        duration: 250,
        easing: "easeInOutCubic",
      });
      tl.add({ backgroundColor: "#a6daff" });
      tl.add({ backgroundColor: "#d9efff" });
    },
    clear() {
      this.animateOperator("clear");
      this.current = "";
      this.answer = "";
      this.logList = "";
      this.calcul = "";
      this.operatorClicked = false;
    },
    sign() {
      this.animateOperator("sign");
      if (this.current != "") {
        this.current =
          this.current.charAt(0) === "-"
            ? this.current.slice(1)
            : `-${this.current}`;
      }
    },
    percent() {
      this.animateOperator("percent");
      if (this.current != "") {
        this.current = `${parseFloat(this.current) / 100}`;
      }
    },
    dot() {
      this.animateNumber("dot");
      if (this.current.indexOf(".") === -1) {
        this.append(".");
      }
    },
    divide() {
      this.animateOperator("divide");
      this.addtoLog("/");
    },
    times() {
      this.animateOperator("times");
      this.addtoLog("*");
    },
    minus() {
      this.animateOperator("minus");
      this.addtoLog("-");
    },
    plus() {
      this.animateOperator("plus");
      this.addtoLog("+");
    },
    evil(fn) {
      return new Function("return " + fn)();
    },

    equal() {
      if (this.operatorClicked === false) {
        if (/\d/.test(this.logList) === false) {
          this.logList = "(" + this.calcul + ")" + this.logList;
        }
        let calcul = this.logList + this.current;
        var regex = /^[0-9-+()/*%. ]*$/;
        if (regex.test(calcul)) {
          this.answer = this.evil(calcul).toString();
        }
      } else {
        this.answer = "ERROR?!!";
      }
      this.calcul = this.logList + this.current;
      this.logList = "";
      this.current = "";
    },
  },
};
</script>

<style scoped>
.calculator {
  display: grid;
  grid-template-rows: repeat(8, minmax(2vh, auto));
  grid-gap: 12px;
  font-weight: 300;
  font-family: "Arial", serif;
  font-size: 18px;
  border-radius: 10px;
}

.btn,
.zero {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #484848;
  background-color: #5ca8e1;
  border-radius: 5px;
  font-size: 1rem;
}

.display,
.answer {
  text-align: right;
  grid-column: 1 / 5;
  display: flex;
  align-items: center;
}

.display {
  color: #dd2f2f;
  overflow: hidden;
  text-overflow: clip;
  font-size: 18px;
}

.answer {
  padding: 5px;
  font-weight: 400;
  font-size: 24px;
  height: 65px;
  color: #ff0000;
  background-color: #8bbfda;
  border-radius: 10px;
  border: 3px #4d83ed inset;
}

.zero {
  grid-column: 1 / 3;
}

.operator {
  background-color: #d9efff;
  color: #002645;
}
</style>
